module.exports = __webpack_public_path__ + "img/AE5008-163.f39e98eb.jpg";